module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<div id=\'library_details\'></div>\n<div id=\'tag_details\'></div>\n';
}
return __p;
};
